import { Box, TableCell } from '@mui/material'
import React from 'react'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'
import { formatCurrency } from '../../../../pages/DataEntryPage/utils/currency'
import { useProcessContext } from '../../../../store'

const TableCellCurrency = ({ isHidden, color, value, previewCurrency, field, width }) => {
  const companyDetails = useProcessContext((state) => state.processContext.companyDetails)
  const currencySubfield = field.id ? field.id : ''

  const { previewText } = useResponsiveTypography()
  return (
    <TableCell
      sx={{
        width: width + 'rem',
        color: color,
        display: isHidden ? 'none' : '',
        fontSize: previewText,
      }}
    >
      <Box sx={{ overflow: 'auto' }}>
        {formatCurrency(value, previewCurrency[currencySubfield], {
          defaultCurrency: companyDetails?.default_currency_code,
        })}
      </Box>
    </TableCell>
  )
}

export default TableCellCurrency
